
export function updateHeadTags({ title, description, keywords = [] }) {
  // Set document title
  if (title) {
    document.title = title;
  }

  // Set meta description
  let descTag = document.querySelector("meta[name='description']");
  if (!descTag) {
    descTag = document.createElement('meta');
    descTag.setAttribute('name', 'description');
    document.head.appendChild(descTag);
  }
  descTag.setAttribute('content', description || '');
  // Set meta description
  let titleTag = document.querySelector("meta[name='title']");
  if (!titleTag) {
    titleTag = document.createElement('meta');
    titleTag.setAttribute('name', 'title');
    document.head.appendChild(titleTag);
  }
  titleTag.setAttribute('content', title || '');

  // Set meta keywords (join array)
  const keywordContent = Array.isArray(keywords) ? keywords.join(', ') : '';
  let keywordsTag = document.querySelector("meta[name='keywords']");
  if (!keywordsTag) {
    keywordsTag = document.createElement('meta');
    keywordsTag.setAttribute('name', 'keywords');
    document.head.appendChild(keywordsTag);
  }
  keywordsTag.setAttribute('content', keywordContent);
}
